import * as React from 'react'
import AuthComponentTabs from './AuthComponentTabs'
import SchoolAuthComponentWrapper from './SchoolAuthComponentWrapper'

interface ISchoolGeneralCourseDetailsProps {
  isDialog?: boolean
  school_details: any
  onSuccess: () => void
}

const AuthComponent = (props: ISchoolGeneralCourseDetailsProps) => {
  return (
    <div style={{ backgroundColor: '#fafafa' }}>
      <SchoolAuthComponentWrapper
        school_details={props.school_details}
        authComponent={
          <AuthComponentTabs
            isDialog={props.isDialog}
            school_details={props.school_details}
            onSuccess={props.onSuccess}
          />
        }
      />
    </div>
  )
}

export default AuthComponent
